/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MetadataItemInput } from './MetadataItemInput';
import {
    MetadataItemInputFromJSON,
    MetadataItemInputFromJSONTyped,
    MetadataItemInputToJSON,
} from './MetadataItemInput';

/**
 * Describes the provider-app-level fields that the Ampersand dashboard should collect from the builder when creating a ProviderApp for this provider. These descriptors tell the dashboard which form fields to render; the submitted values are stored in ProviderApp.metadata.
 * @export
 * @interface ProviderAppMetadata1
 */
export interface ProviderAppMetadata1 {
    /**
     * Descriptors for fields stored in ProviderApp.metadata.authQueryParams (e.g., optional_scope for HubSpot).
     * @type {Array<MetadataItemInput>}
     * @memberof ProviderAppMetadata1
     */
    authQueryParams?: Array<MetadataItemInput>;
    /**
     * Descriptors for fields stored in ProviderApp.metadata.providerParams (e.g., packageInstallURL for Salesforce, gcpProjectId for Gmail).
     * @type {Array<MetadataItemInput>}
     * @memberof ProviderAppMetadata1
     */
    providerParams?: Array<MetadataItemInput>;
}

/**
 * Check if a given object implements the ProviderAppMetadata1 interface.
 */
export function instanceOfProviderAppMetadata1(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ProviderAppMetadata1FromJSON(json: any): ProviderAppMetadata1 {
    return ProviderAppMetadata1FromJSONTyped(json, false);
}

export function ProviderAppMetadata1FromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderAppMetadata1 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'authQueryParams': !exists(json, 'authQueryParams') ? undefined : ((json['authQueryParams'] as Array<any>).map(MetadataItemInputFromJSON)),
        'providerParams': !exists(json, 'providerParams') ? undefined : ((json['providerParams'] as Array<any>).map(MetadataItemInputFromJSON)),
    };
}

export function ProviderAppMetadata1ToJSON(value?: ProviderAppMetadata1 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'authQueryParams': value.authQueryParams === undefined ? undefined : ((value.authQueryParams as Array<any>).map(MetadataItemInputToJSON)),
        'providerParams': value.providerParams === undefined ? undefined : ((value.providerParams as Array<any>).map(MetadataItemInputToJSON)),
    };
}

